/**
 * Quick-Add Popup for Recommendation Cards v4
 * - Variant selection (color + size)
 * - Image changes on color selection
 * - Native theme cart refresh
 */
(function() {
  'use strict';

  /* Fix: Refresh recommendations after any cart change */
  document.documentElement.addEventListener('cart:refresh', function() {
    setTimeout(function() {
      var rec = document.querySelector('cart-drawer-recommendations');
      if (rec) {
        /* Clear the internal cache so recommendations re-fetch */
        try { rec.constructor.recommendationsCache = {}; } catch(e) {}
        /* Re-trigger the recommendation loading */
        if (typeof rec.connectedCallback === 'function') {
          rec.connectedCallback();
        }
      }
    }, 300);
  });

  document.addEventListener('click', function(e) {
    var triggerBtn = e.target.closest('.hb-rec-card__add-btn:not(.hb-rec-card__add-btn--sold-out)');
    var closeBtn = e.target.closest('.hb-quick-add__close');
    var colorBtn = e.target.closest('.hb-quick-add__color:not(.hb-quick-add__color--unavailable)');
    var sizeBtn = e.target.closest('.hb-quick-add__size:not(.hb-quick-add__size--unavailable)');
    var submitBtn = e.target.closest('.hb-quick-add__submit:not(:disabled)');

    if (triggerBtn) {
      e.preventDefault();
      e.stopPropagation();
      var card = triggerBtn.closest('.hb-rec-card');
      if (!card || card.classList.contains('hb-rec-card--popup-open')) return;
      closeAllPopups();
      card.classList.add('hb-rec-card--popup-open');
      initPopup(card);
      return;
    }

    if (closeBtn) {
      e.preventDefault();
      closeBtn.closest('.hb-rec-card').classList.remove('hb-rec-card--popup-open');
      return;
    }

    if (colorBtn) {
      e.preventDefault();
      var popup = colorBtn.closest('.hb-quick-add');
      popup.querySelectorAll('.hb-quick-add__color').forEach(function(b) {
        b.classList.remove('hb-quick-add__color--selected');
      });
      colorBtn.classList.add('hb-quick-add__color--selected');
      updateImage(popup);
      updateAvailability(popup);
      return;
    }

    if (sizeBtn) {
      e.preventDefault();
      var popup = sizeBtn.closest('.hb-quick-add');
      popup.querySelectorAll('.hb-quick-add__size').forEach(function(b) {
        b.classList.remove('hb-quick-add__size--selected');
      });
      sizeBtn.classList.add('hb-quick-add__size--selected');
      updateAvailability(popup);
      return;
    }

    if (submitBtn) {
      e.preventDefault();
      addToCart(submitBtn.closest('.hb-quick-add'), submitBtn.closest('.hb-rec-card'));
      return;
    }

    if (!e.target.closest('.hb-rec-card--popup-open')) {
      closeAllPopups();
    }
  });

  function closeAllPopups() {
    document.querySelectorAll('.hb-rec-card--popup-open').forEach(function(c) {
      c.classList.remove('hb-rec-card--popup-open');
    });
  }

  function getVariants(popup) {
    try {
      var raw = popup.dataset.variants;
      var decoded = raw.replace(/&quot;/g, '"').replace(/&amp;/g, '&').replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&#39;/g, "'");
      return JSON.parse(decoded);
    } catch(e) {
      return [];
    }
  }

  function initPopup(card) {
    var popup = card.querySelector('.hb-quick-add');
    if (!popup) return;

    /* Reset */
    popup.querySelectorAll('[class*="--selected"]').forEach(function(b) {
      b.className = b.className.replace(/--selected/g, '').trim();
    });
    popup.querySelectorAll('[class*="--unavailable"]').forEach(function(b) {
      b.className = b.className.replace(/--unavailable/g, '').trim();
    });

    /* Pre-select first available variant */
    var variants = getVariants(popup);
    var firstAvailable = variants.find(function(v) { return v.available; });

    if (firstAvailable) {
      var colorBtn = popup.querySelector('.hb-quick-add__color[data-value="' + firstAvailable.option1 + '"]');
      if (colorBtn) colorBtn.classList.add('hb-quick-add__color--selected');

      var sizeBtn = popup.querySelector('.hb-quick-add__size[data-value="' + firstAvailable.option2 + '"]');
      if (sizeBtn) sizeBtn.classList.add('hb-quick-add__size--selected');

      updateAvailability(popup);
    }
  }

  function updateImage(popup) {
    var card = popup.closest('.hb-rec-card');
    var img = card.querySelector('.hb-rec-card__image');
    if (!img) return;

    var selectedColor = popup.querySelector('.hb-quick-add__color--selected');
    if (!selectedColor) return;

    var colorVal = selectedColor.dataset.value;
    var variants = getVariants(popup);

    /* Find first variant with this color that has an image */
    var match = variants.find(function(v) {
      return v.option1 === colorVal && v.featured_image;
    });

    if (match && match.featured_image && match.featured_image.src) {
      /* Build Shopify CDN URL at desired width */
      var newSrc = match.featured_image.src.replace(/(\.[a-z]+)\?/, '_280x$1?');
      /* Fallback: just use the src directly if replacement doesn't work */
      if (newSrc === match.featured_image.src) {
        newSrc = match.featured_image.src;
      }
      img.src = newSrc;
      img.alt = match.featured_image.alt || card.querySelector('.hb-rec-card__title').textContent.trim();
    }
  }

  function updateAvailability(popup) {
    var variants = getVariants(popup);
    var selectedColor = popup.querySelector('.hb-quick-add__color--selected');
    var selectedSize = popup.querySelector('.hb-quick-add__size--selected');
    var submit = popup.querySelector('.hb-quick-add__submit');

    var colorVal = selectedColor ? selectedColor.dataset.value : null;
    var sizeVal = selectedSize ? selectedSize.dataset.value : null;

    if (colorVal) {
      popup.querySelectorAll('.hb-quick-add__size').forEach(function(btn) {
        var sv = btn.dataset.value;
        var hasMatch = variants.some(function(v) {
          return v.available && v.option1 === colorVal && v.option2 === sv;
        });
        btn.classList.toggle('hb-quick-add__size--unavailable', !hasMatch);
        if (!hasMatch && btn.classList.contains('hb-quick-add__size--selected')) {
          btn.classList.remove('hb-quick-add__size--selected');
          sizeVal = null;
        }
      });
    }

    if (sizeVal) {
      popup.querySelectorAll('.hb-quick-add__color').forEach(function(btn) {
        var cv = btn.dataset.value;
        var hasMatch = variants.some(function(v) {
          return v.available && v.option1 === cv && v.option2 === sizeVal;
        });
        btn.classList.toggle('hb-quick-add__color--unavailable', !hasMatch);
        if (!hasMatch && btn.classList.contains('hb-quick-add__color--selected')) {
          btn.classList.remove('hb-quick-add__color--selected');
          colorVal = null;
        }
      });
    }

    /* Re-read after potential deselection */
    selectedColor = popup.querySelector('.hb-quick-add__color--selected');
    selectedSize = popup.querySelector('.hb-quick-add__size--selected');
    colorVal = selectedColor ? selectedColor.dataset.value : null;
    sizeVal = selectedSize ? selectedSize.dataset.value : null;

    if (colorVal && sizeVal) {
      var match = variants.find(function(v) {
        return v.available && v.option1 === colorVal && v.option2 === sizeVal;
      });
      if (match) {
        submit.disabled = false;
        submit.textContent = 'Hinzufügen';
        submit.dataset.variantId = match.id;
      } else {
        submit.disabled = true;
        submit.textContent = 'Nicht verfügbar';
      }
    } else {
      submit.disabled = true;
      submit.textContent = 'Bitte wählen';
    }
  }

  function addToCart(popup, card) {
    var submit = popup.querySelector('.hb-quick-add__submit');
    var variantId = submit.dataset.variantId;
    if (!variantId) return;

    submit.disabled = true;
    submit.textContent = '...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{ id: parseInt(variantId), quantity: 1 }],
        sections: 'mini-cart'
      })
    })
    .then(function(res) { return res.json(); })
    .then(function(addResponse) {
      submit.textContent = 'Hinzugefuegt';

      /* Close popup */
      setTimeout(function() {
        card.classList.remove('hb-rec-card--popup-open');
      }, 400);

      /* Fetch fresh cart data and trigger theme refresh */
      fetch('/cart.js')
        .then(function(r) { return r.json(); })
        .then(function(cartContent) {
          cartContent['sections'] = addResponse['sections'] || {};

          /* Update cart count badges */
          document.documentElement.dispatchEvent(new CustomEvent('cart:updated', {
            bubbles: true,
            detail: { cart: cartContent }
          }));

          /* Refresh the entire cart drawer with new content */
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
            bubbles: true,
            detail: {
              cart: cartContent,
              openMiniCart: false
            }
          }));
        });
    })
    .catch(function() {
      submit.textContent = 'Fehler';
      submit.disabled = false;
    });
  }
})();